// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"360":"481e03","381":"2b4862","403":"26c98c","512":"a9c7bd"}[chunkId] + ".js";
};